import { connect } from 'react-redux'
import { AppStateType } from '../../reducers'
import { selectMediaTypeGroupsAsOptions } from '../../selectors/mediaTypesGroups'
import { selectPublishingLocationsAsOptions } from '../../selectors/publishingLocations'
import { selectAreaWritable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { CapabilityForm as Form } from './CapabilityForm'

const mapStateToProps = (state: AppStateType) => ({
  mediaTypesGroups: selectMediaTypeGroupsAsOptions(state),
  publishingLocations: selectPublishingLocationsAsOptions(state),
  editable: selectAreaWritable(state, {
    area: AREA_CONSTANTS.SETTINGS_CAPABILITY,
  }),
})

export const CapabilityForm = connect(mapStateToProps)(Form)
